import React from 'react';
import { BarChart, Bar, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const ageIntervals = ["1w", "5d", "48h", "24h", "12h", "6h", "4h", "2h", "1h", "30m", "15m", "5m"];

const ageColors = {
  "1w": "#8018e7",
  "5d": "#6c20a8",
  "48h": "#582eb9",
  "24h": "#444ac9",
  "12h": "#2f68d9",
  "6h": "#3b82f6",
  "4h": "#4aa1e5",
  "2h": "#5bc0d4",
  "1h": "#6ddfb3",
  "30m": "#82ca9d",
  "15m": "#96c284",
  "5m": "#e2ff68",
};

const MiniAgeMapChart = ({ data }) => {
  if (!data) {
    return <span style={{ color: "#888" }}>. . .</span>;
  }

  const total = ageIntervals.reduce((sum, key) => sum + (data[key] || 0), 0);

  const chartData = ageIntervals.reduce((acc, interval) => {
    acc[interval] = total ? ((data[interval] || 0) / total) * 100 : 0;
    return acc;
  }, {});

  return (
    <div style={{ width: '120px', height: '20px' }}>
      <ResponsiveContainer width={120} height={20}>
        <BarChart layout="vertical" data={[chartData]} barGap={0} barCategoryGap={0}>
          <XAxis hide type="number" domain={[0, 100]} />
          <YAxis hide type="category" />
          <Tooltip
            cursor={false}
            position={{ y: -21 }}
            content={({ payload }) => {
              if (!payload || !payload.length) return null;

              const entries = payload.filter(entry => entry.value > 0);
              if (!entries.length) return null;

              return (
                <div style={{
                  background: '#222',
                  padding: '4px 8px',
                  borderRadius: '5px',
                  color: '#fff',
                  zIndex: 99999,
                  display: 'flex',
                  gap: '8px',
                  whiteSpace: 'nowrap'
                }}>
                  {entries.map((entry, idx) => (
                    <span key={entry.name}>
                      <strong>{entry.name}</strong>: {entry.value.toFixed(1)}%{idx < entries.length - 1 ? ',' : ''}
                    </span>
                  ))}
                </div>
              );
            }}
          />
          {ageIntervals.map(interval => (
            <Bar key={interval} dataKey={interval} stackId="a" fill={ageColors[interval]} isAnimationActive={false} />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MiniAgeMapChart;
